/* eslint-disable */
import { Cog } from 'lucide-react';
import { useAnalysisStore } from '../../AssetAnalysisStore';
import { useShallow } from 'zustand/react/shallow';
import { cn } from '@/lib/utils';

function getIconByName(name, color, size = 16) {
    switch (name) {
        case 'Settings':
            return <Cog color={color} size={size} strokeWidth={2.5} />;
        default:
            return <Cog color={color} size={size} strokeWidth={2.5} />;
    }
}

const AnalysisTabs = () => {
    const { analysisTabs, activeAnalysisTab, setActiveAnalysisTab } = useAnalysisStore(
        useShallow(state => ({
            analysisTabs: state.analysisTabs,
            activeAnalysisTab: state.activeAnalysisTab,
            setActiveAnalysisTab: state.setActiveAnalysisTab
        }))
    );

    return (
        <div className="bg-white">
            <div className="flex border-b border-b-orange-400 rounded-none bg-transparent h-auto p-0 justify-start shrink-0">
                {analysisTabs.map(tab => (
                    <button
                        key={tab.key}
                        disabled={tab.disabled}
                        onClick={() => setActiveAnalysisTab(tab.key)}
                        className={cn(
                            'rounded-none py-2 px-4 text-sm border-b-2 transition-all duration-200 ease-in-out',
                            'data-[state=active]:border-orange-400 data-[state=active]:text-foreground data-[state=inactive]:border-transparent data-[state=inactive]:text-muted-foreground',
                            tab.key === activeAnalysisTab ? 'border-b-orange-400 font-bold text-black' : 'border-b-transparent',
                            tab.disabled && 'opacity-50 cursor-not-allowed text-gray-400'
                        )}
                        data-state={tab.key === activeAnalysisTab ? 'active' : 'inactive'}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default AnalysisTabs;